const getFullHour = (date: string | Date): string => {
  if (typeof date !== 'string') date = date?.toJSON();

  const fullHour: string = `${new Date(date).getHours()}:${new Date(date).getMinutes()}`
    .split(':')
    .map((el) => (el.length === 1 ? `0${el}` : el))
    .join(':');

  return fullHour;
};

export default getFullHour;
